<template lang="pug">
va-card(:title="$t('menu.shipping-prices')")
    .flex.xs12(:style="{textAlign: 'right'}")
        <!-- va-button(default normal color="dark" icon="fa fa-plus" href="/admin/shipping-prices/0") {{ $t('shippingPrices.addShippingPrice') }} -->

    va-data-table(:fields='fields' :data='shippings' :per-page='parseInt(perPage)' :loading='loading')
        template(slot='cartValue' slot-scope='props')
            span(v-html="$formatPrice(props.rowData.cartValue)")

        template(slot='price' slot-scope='props')
            span(v-html="$formatPrice(props.rowData.price)")

        template(slot='actions' slot-scope='props')
            va-button.ma-0(flat small color="gray" icon="fa fa-pencil" :href="'/admin/shipping-prices/'+props.rowData.uuid") {{ $t('tables.edit') }}
            <!-- va-button.ma-0(flat small color="danger" icon="fa fa-trash" @click.prevent="openModalDelete(props.rowData)") {{ $t('tables.delete') }} -->

    .modals
        va-modal(v-model='showModalDelete' size='small' :title=" $t('shippingPrices.modal.deleteShippingTitle')" :message=" $t('shippingPrices.modal.deleteShippingText') " :okText=" $t('modal.confirm') " :cancelText=" $t('modal.cancel') " @ok='deleteShipping' @cancel='abortDeleteShipping')

</template>

<script>
export default {
    props: ["shippings", "loading"],
    data() {
        return {
            perPage: "20",
            perPageOptions: ["20", "50", "100"],
            createdPage: 1,
            justCreated: true,
            animationHolder: null,
            createdPage: 1,
            showModalDelete: false,
        };
    },
    computed: {
        fields() {
            return [
                {
                    name: "type",
                    title: this.$t("tables.headings.shippingType"),
                    width: "20%"
                },
                {
                    name: "__slot:cartValue",
                    title: this.$t("tables.headings.shippingCartValue"),
                    width: "20%"
                },
                {
                    name: "__slot:price",
                    title: this.$t("tables.headings.shippingPrice"),
                    width: "10%"
                },
                {
                    name: '__slot:actions',
                    width: '20%',
                    dataClass: 'text-right',
                }
            ];
        }
    },
    methods: {
        goTo(shippingPrice) {
            this.$router.push({
                path: "/admin/shipping-prices/" + shippingPrice.uuid
            });
        },
        openModalDelete(obj){
            this.toDelete = obj;
            this.showModalDelete = true;
        },
        abortDeleteShipping(){
            this.toDelete = null;
        },
        deleteShipping(){

            this.$axios.delete('api/shippingPrice/deleteRule',{data:{uuid:this.toDelete.uuid}}).then(axRes => {
                this.showToast(
                this.$t('shippingPrice.deletedSusseccfully'),
                {
                    icon:'fa-check',
                    position: 'bottom-right',
                    duration: 3000,
                    fullWidth: false,
                    className: 'vuestic-toast'
                },
                );
                this.$emit('reload');
            
            }).catch(axErr => {
                this.showToast(
                this.$t('system.genericError'),
                {
                    icon:'fa-warning',
                    position: 'bottom-right',
                    duration: 10000,
                    fullWidth: false,
                    className: 'vuestic-toast error'
                },
                )
            })
        },
    },
};
</script>
